import { useParams } from "react-router-dom";
import KycReminderDialog from "../components/kyc-reminder-dialog";
import InvoicesTab from "./components/invoices-tab";
import KycTab from "./components/kyc-tab";
import PublisherHeader from "./components/publisher-header";
import PublisherTabs from "./components/publisher-tabs";
import usePublisherDetails from "./hooks/use-publisher-details";

const PublisherDetails = () => {
    const { id } = useParams();
    const {
        publisher, publisherName, email, brands, crumbs,
        activeTab, setActiveTab, tabCounts, kyc, kycTab, invoicesTab
    } = usePublisherDetails(id);

    return (
        <div className="p-6">
            <PublisherHeader publisher={publisher} publisherName={publisherName} email={email} brands={brands} crumbs={crumbs} />

            <PublisherTabs activeTab={activeTab} onChange={setActiveTab} counts={tabCounts} />

            <div className="mt-6">
                {activeTab === "kyc" && <KycTab {...kycTab} />}
                {activeTab === "invoices" && <InvoicesTab invoicesTab={invoicesTab} />}
            </div>

            <KycReminderDialog kyc={kyc} />
        </div>
    );
};

export default PublisherDetails;
